import {
  Sparkles, ListChecks, Share2, BookmarkPlus, FileText, FolderPlus, CalendarPlus, MessageCircle, Repeat, MoreHorizontal,
} from "lucide-react";
import { Eyebrow, SectionTitle, SectionSub } from "@/components/web/atoms";
import { Reveal, BrowserFrame } from "@/components/web/home/primitives";

/* Section 7 — AI answers become action. Shows a realistic result card with the
   Action Bar underneath: research that leads somewhere. */
const ACTIONS = [
  { icon: ListChecks, label: "Create Task", primary: true },
  { icon: Share2, label: "Share With Team", primary: true },
  { icon: BookmarkPlus, label: "Save to Knowledge", primary: true },
  { icon: FileText, label: "Create Document" },
  { icon: FolderPlus, label: "Add to Project" },
  { icon: CalendarPlus, label: "Schedule Meeting" },
  { icon: MessageCircle, label: "Ask Another AI" },
  { icon: Repeat, label: "Automate This" },
];

export default function ActionBarSection() {
  return (
    <section
      id="action-bar"
      className="relative py-20 md:py-28 px-5 border-t border-[var(--w-hairline)] bg-[var(--w-bg2)] scroll-mt-20"
      data-testid="home-action-bar"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal className="max-w-3xl">
          <Eyebrow tone="brand" className="mb-4">AI answers become action</Eyebrow>
          <SectionTitle>Research should lead somewhere.</SectionTitle>
          <SectionSub className="mt-5">
            Whether the answer comes from one model, several models, a document or a meeting,
            TeamNest helps turn it into the next step.
          </SectionSub>
        </Reveal>

        <Reveal delay={120} className="mt-10 max-w-3xl">
          <BrowserFrame url="teamnest.ai/research">
            <div className="p-5 sm:p-6 bg-[var(--w-bg)]">
              {/* AI result card */}
              <div className="rounded-[14px] border border-[var(--w-ai)]/30 bg-[var(--w-ai-tint)]/40 p-4">
                <div className="flex items-center gap-1.5 mb-2">
                  <Sparkles className="w-3.5 h-3.5 text-[var(--w-ai)]" />
                  <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--w-ai)]">Synthesized · 3 models</span>
                </div>
                <p className="text-[13.5px] leading-6 text-[var(--w-text-dim)]">
                  Recommended entry markets are the US and Germany. The US offers the fastest volume ramp;
                  Germany balances the portfolio once compliance is in place. Next: validate pricing and
                  line up two reference customers.
                </p>
              </div>

              {/* Action bar */}
              <div className="mt-5">
                <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-[var(--w-text-mute)] mb-3">
                  Do something with this
                </div>
                <div className="flex flex-wrap gap-2">
                  {ACTIONS.map((a) => (
                    <span
                      key={a.label}
                      data-testid={`action-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-[10px] border text-[12.5px] font-medium transition-colors ${
                        a.primary
                          ? "border-[var(--w-brand)]/40 bg-[var(--w-brand-tint)] text-[var(--w-brand)]"
                          : "border-[var(--w-hairline)] bg-[var(--w-surface)] text-[var(--w-text-dim)]"
                      }`}
                    >
                      <a.icon className="w-3.5 h-3.5" /> {a.label}
                    </span>
                  ))}
                  <span className="inline-flex items-center gap-1.5 h-9 px-3 rounded-[10px] border border-[var(--w-hairline)] bg-[var(--w-surface)] text-[12.5px] font-medium text-[var(--w-text-mute)]">
                    <MoreHorizontal className="w-3.5 h-3.5" /> More
                  </span>
                </div>
              </div>
            </div>
          </BrowserFrame>
        </Reveal>
      </div>
    </section>
  );
}
